import React from 'react';
import { useNativeAuth, UseNativeAuthReturn } from '@mahendran/shared-frontend-config';

interface AuthContextValue extends UseNativeAuthReturn {
  register: () => Promise<void>;
}

const AuthContext = React.createContext<AuthContextValue | undefined>(undefined);

export const useAuth = () => {
  const context = React.useContext(AuthContext);
  if (context === undefined) {
    throw new Error('useAuth must be used within AuthProvider');
  }
  return context;
};

export const AuthProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const auth = useNativeAuth();

  const register = React.useCallback(async () => {
    window.location.href = '/register';
  }, []);

  const value = React.useMemo<AuthContextValue>(
    () => ({
      ...auth,
      register,
    }),
    [auth, register]
  );

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
